<!-- TEMPLATE -->
<template>
  <div class="dean-button-group">
    <span class="dean-button-group-items">
      <slot></slot>
    </span>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

// COMPONENTS
@Component
export default class deanButtonGroup extends Vue {}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN BUTTON GROUP
.dean-button-group {
  display: inline-block;
  padding: 5px 10px 5px 10px;
  margin: 0;

  /* dean button */
  .dean-button-group-items {
    display: inline-flex;
    cursor: pointer;
    text-decoration: none;
    text-transform: lowercase;
    border: none;
    overflow: hidden;
    @include border-radius(10px);
  }
}
</style>
